export const licenceKeys = {
	options: ["licences", "options"],
};
